import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AutoCompletionService {

    constructor(public apiService: ApiService) {

    }

    search(collection:string, field:string, query:string, model:any){
        this.apiService.get('autoCompletion', 'collection=' + collection + '&field=' + field + '&query=' + query).subscribe(res => {
             model.autocompletionResult = res.data;
        }, (_err) => {
            model.autocompletionResult = [];
            this.apiService.error(_err);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/autoCompletion.service.ts